var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallImage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 333,
    viewBox: "0 0 375 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path_call-image2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_31",
    "data-name": "\\u9577\\u65B9\\u5F62 31",
    width: 375,
    height: 333,
    transform: "translate(0 479)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2_call-image2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "MASK",
    width: 375,
    height: 150,
    transform: "translate(0 446)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3_call-image2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3",
    "data-name": "\\u9577\\u65B9\\u5F62 3",
    width: 115,
    height: 82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4_call-image2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_22",
    "data-name": "\\u9577\\u65B9\\u5F62 22",
    width: 172,
    height: 98,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7_4",
    "data-name": "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7 4",
    transform: "translate(0 -479)",
    clipPath: "url(#clip-path_call-image2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_6",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_215",
    "data-name": "\\u30D1\\u30B9 215",
    d: "M-492-5745.429H-868v-293.5c3.981,4.694,7.91,9.193,12.237,12.644a31.248,31.248,0,0,0,7.476,4.552,21.753,21.753,0,0,0,8.521,1.741,28.231,28.231,0,0,0,9.874-1.67,28.317,28.317,0,0,0,7.842-4.463c4.714-3.721,8.573-8.734,12.658-14.041l.014-.019.009-.012.008-.009.014-.017c1.252-1.628,2.476-3.216,3.7-4.742,4.653-5.817,9.363-10.174,14-12.951a24.5,24.5,0,0,1,12.616-3.8,22.249,22.249,0,0,1,9.131,2.035,33.56,33.56,0,0,1,8.075,5.278l.061.052c5.279,4.547,11.258,9.7,18.457,13.646a52.948,52.948,0,0,0,26.085,6.734c.918,0,1.895-.024,2.9-.071a48.886,48.886,0,0,0,14.416-3.005,68.045,68.045,0,0,0,12.72-6.339c7.88-4.945,14.339-10.776,19.529-15.461l.194-.173.015-.015.038-.034,0,0,.075-.068.015-.012c.984-.888,2.024-1.825,2.971-2.656a36.351,36.351,0,0,1,9.671-6.024,34.592,34.592,0,0,1,13.535-2.774,37.752,37.752,0,0,1,15.661,3.549,60.776,60.776,0,0,1,17.517,12.655,46.456,46.456,0,0,0,12.816,9.4,28.358,28.358,0,0,0,12.111,2.821,29.054,29.054,0,0,0,10.38-2,42.941,42.941,0,0,0,9.578-5.279c5.323-3.821,10.675-9.087,16.361-16.1a35.987,35.987,0,0,1,11.631-9.793A24.83,24.83,0,0,1-523.911-6078c6.333,0,12.09,2.347,16.4,4.392a19.634,19.634,0,0,0,8.373,1.739,27.058,27.058,0,0,0,7.14-.988v327.428Z",
    transform: "translate(868 6557.43)",
    fill: "#c9eef6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "illust",
    transform: "translate(0 134)",
    clipPath: "url(#clip-path-2_call-image2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illust03",
    transform: "translate(135 504)",
    clipPath: "url(#clip-path-3_call-image2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_89",
    "data-name": "\\u30D1\\u30B9 89",
    d: "M3.729,82.494H111.276a3.454,3.454,0,0,0,3.445-3.443v-.333a3.455,3.455,0,0,0-3.445-3.443H3.729A3.456,3.456,0,0,0,.283,78.718v.333a3.455,3.455,0,0,0,3.446,3.443",
    transform: "translate(-0.003 -0.775)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_2",
    "data-name": "\\u9577\\u65B9\\u5F62 2",
    d: "M3.479,0H110.96a3.478,3.478,0,0,1,3.478,3.478V3.74a3.479,3.479,0,0,1-3.479,3.479H3.479A3.479,3.479,0,0,1,0,3.74V3.479A3.479,3.479,0,0,1,3.479,0Z",
    transform: "translate(0.281 74.501)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_90",
    "data-name": "\\u30D1\\u30B9 90",
    d: "M35.745,75.278h0a3.046,3.046,0,0,1,3.047-3.044h4.3V69.721h13.06v8.6H38.792a3.046,3.046,0,0,1-3.047-3.044",
    transform: "translate(-0.335 -0.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_91",
    "data-name": "\\u30D1\\u30B9 91",
    d: "M35.745,75.278h0a3.046,3.046,0,0,1,3.047-3.044h4.3V69.721h13.06v8.6H38.792A3.046,3.046,0,0,1,35.745,75.278Z",
    transform: "translate(-0.335 -0.718)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_92",
    "data-name": "\\u30D1\\u30B9 92",
    d: "M70.308,51.414H56.225V69.4H43.165V46.462a7.515,7.515,0,0,1,7.519-7.511h32.1A12.47,12.47,0,0,1,70.308,51.414",
    transform: "translate(-0.404 -0.401)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_93",
    "data-name": "\\u30D1\\u30B9 93",
    d: "M70.308,51.414H56.225V69.4H43.165V46.462a7.515,7.515,0,0,1,7.519-7.511h32.1A12.47,12.47,0,0,1,70.308,51.414Z",
    transform: "translate(-0.404 -0.401)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_94",
    "data-name": "\\u30D1\\u30B9 94",
    d: "M71.029,38.951l-14.7,28.512A7.232,7.232,0,0,0,62.77,78.006h28.9V66.536H71.287S86.255,45.912,86.255,38.951Z",
    transform: "translate(-0.52 -0.401)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_95",
    "data-name": "\\u30D1\\u30B9 95",
    d: "M71.029,38.951l-14.7,28.512A7.232,7.232,0,0,0,62.77,78.006h28.9V66.536H71.287S86.255,45.912,86.255,38.951Z",
    transform: "translate(-0.52 -0.401)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_96",
    "data-name": "\\u30D1\\u30B9 96",
    d: "M92.016,78.256h17.368a3.072,3.072,0,0,0,.8-6.038c-4.328-1.15-7.7-5.3-9.731-7.722a3.465,3.465,0,0,0-6.116,2.227v.063H92.016Z",
    transform: "translate(-0.862 -0.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_97",
    "data-name": "\\u30D1\\u30B9 97",
    d: "M92.016,78.256h17.368a3.072,3.072,0,0,0,.8-6.038c-4.328-1.15-7.7-5.3-9.731-7.722a3.465,3.465,0,0,0-6.116,2.227v.063H92.016Z",
    transform: "translate(-0.862 -0.651)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_98",
    "data-name": "\\u30D1\\u30B9 98",
    d: "M62.408,47.132l3.956,1.083.461-.895Z",
    transform: "translate(-0.584 -0.485)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_99",
    "data-name": "\\u30D1\\u30B9 99",
    d: "M62.408,47.132l3.956,1.083.461-.895Z",
    transform: "translate(-0.584 -0.485)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_100",
    "data-name": "\\u30D1\\u30B9 100",
    d: "M63.888,46.959H98.025a5.35,5.35,0,0,0,5.352-5.347v-.134a5.381,5.381,0,0,0-4.652-5.3,15.992,15.992,0,0,1-11.089-6.282c-4.77-5.716-10-3.634-13.646-9.656-.73-1.206-1.39-2.258-1.979-3.167A10.945,10.945,0,0,0,52.39,26.338L57.5,42.3a6.706,6.706,0,0,0,6.388,4.659",
    transform: "translate(-0.486 -0.124)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_101",
    "data-name": "\\u30D1\\u30B9 101",
    d: "M63.888,46.959H98.025a5.35,5.35,0,0,0,5.352-5.347v-.134a5.381,5.381,0,0,0-4.652-5.3,15.992,15.992,0,0,1-11.089-6.282c-4.77-5.716-10-3.634-13.646-9.656-.73-1.206-1.39-2.258-1.979-3.167A10.945,10.945,0,0,0,52.39,26.338L57.5,42.3A6.706,6.706,0,0,0,63.888,46.959Z",
    transform: "translate(-0.486 -0.124)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_102",
    "data-name": "\\u30D1\\u30B9 102",
    d: "M62.624,10.437a6.58,6.58,0,1,0-6.58,6.574,6.577,6.577,0,0,0,6.58-6.574",
    transform: "translate(-0.463 -0.039)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_4",
    "data-name": "\\u6955\\u5186\\u5F62 4",
    cx: 6.58,
    cy: 6.574,
    rx: 6.58,
    ry: 6.574,
    transform: "translate(49.001 3.824)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_3",
    "data-name": "\\u7DDA 3",
    x1: 1.511,
    y2: 0.043,
    transform: "translate(51.341 10.186)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_103",
    "data-name": "\\u30D1\\u30B9 103",
    d: "M50.076,8.6l-.161,0A1.67,1.67,0,0,0,48.3,10.316l0,.161A1.673,1.673,0,0,0,50.015,12.1l.16,0a1.671,1.671,0,0,0,1.62-1.713l0-.16A1.673,1.673,0,0,0,50.076,8.6Z",
    transform: "translate(-0.452 -0.088)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_104",
    "data-name": "\\u30D1\\u30B9 104",
    d: "M55.129,8.455l-.161,0a1.67,1.67,0,0,0-1.619,1.712l0,.161a1.673,1.673,0,0,0,1.715,1.618l.16,0a1.671,1.671,0,0,0,1.62-1.713l0-.16A1.673,1.673,0,0,0,55.129,8.455Z",
    transform: "translate(-0.5 -0.087)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_105",
    "data-name": "\\u30D1\\u30B9 105",
    d: "M32.722,59.1a16.168,16.168,0,0,0-6.271-12.8,5.509,5.509,0,0,1-2.145-4.348V37.341a5.459,5.459,0,0,1,2.109-4.322A16.177,16.177,0,0,0,24.96,6.384a5.7,5.7,0,0,1-2.78-4.836v-.1A1.168,1.168,0,0,0,21.011.284H18.24a1.168,1.168,0,0,0-1.168,1.167V3.006a.994.994,0,0,1-.967,1,16.2,16.2,0,0,0,.4,32.4c.5,0,.984-.026,1.468-.069v6.635C17.486,42.921,17,42.9,16.5,42.9a16.2,16.2,0,0,0-1.151,32.368q.37.025.737.034a1,1,0,0,1,.984,1v1.542a1.168,1.168,0,0,0,1.168,1.168h2.771a1.169,1.169,0,0,0,1.169-1.168,5.707,5.707,0,0,1,2.731-4.882A16.186,16.186,0,0,0,32.722,59.1M16.5,31.563A11.367,11.367,0,1,1,27.881,20.195,11.373,11.373,0,0,1,16.5,31.563m0,38.9A11.367,11.367,0,1,1,27.881,59.1,11.373,11.373,0,0,1,16.5,70.467",
    transform: "translate(-0.003 -0.003)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_106",
    "data-name": "\\u30D1\\u30B9 106",
    d: "M32.722,59.1a16.168,16.168,0,0,0-6.271-12.8,5.509,5.509,0,0,1-2.145-4.348V37.341a5.459,5.459,0,0,1,2.109-4.322A16.177,16.177,0,0,0,24.96,6.384a5.7,5.7,0,0,1-2.78-4.836v-.1A1.168,1.168,0,0,0,21.011.284H18.24a1.168,1.168,0,0,0-1.168,1.167V3.006a.994.994,0,0,1-.967,1,16.2,16.2,0,0,0,.4,32.4c.5,0,.984-.026,1.468-.069v6.635C17.486,42.921,17,42.9,16.5,42.9a16.2,16.2,0,0,0-1.151,32.368q.37.025.737.034a1,1,0,0,1,.984,1v1.542a1.168,1.168,0,0,0,1.168,1.168h2.771a1.169,1.169,0,0,0,1.169-1.168,5.707,5.707,0,0,1,2.731-4.882A16.186,16.186,0,0,0,32.722,59.1ZM16.5,31.563A11.367,11.367,0,1,1,27.881,20.195,11.373,11.373,0,0,1,16.5,31.563Zm0,38.9A11.367,11.367,0,1,1,27.881,59.1,11.373,11.373,0,0,1,16.5,70.467Z",
    transform: "translate(-0.003 -0.003)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_107",
    "data-name": "\\u30D1\\u30B9 107",
    d: "M16.548,48.226A11.367,11.367,0,1,0,27.927,59.594,11.373,11.373,0,0,0,16.548,48.226",
    transform: "translate(-0.048 -0.496)",
    fill: "#b3dfef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_108",
    "data-name": "\\u30D1\\u30B9 108",
    d: "M16.548,48.226A11.367,11.367,0,1,0,27.927,59.594,11.373,11.373,0,0,0,16.548,48.226Z",
    transform: "translate(-0.048 -0.496)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_109",
    "data-name": "\\u30D1\\u30B9 109",
    d: "M16.548,8.917A11.367,11.367,0,1,0,27.927,20.285,11.373,11.373,0,0,0,16.548,8.917",
    transform: "translate(-0.048 -0.092)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_110",
    "data-name": "\\u30D1\\u30B9 110",
    d: "M16.548,8.917A11.367,11.367,0,1,0,27.927,20.285,11.373,11.373,0,0,0,16.548,8.917Z",
    transform: "translate(-0.048 -0.092)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_111",
    "data-name": "\\u30D1\\u30B9 111",
    d: "M27.869,21.659c-7.725-5.034-15.381-5.047-21.091,4.52a11.38,11.38,0,0,0,21.091-4.52",
    transform: "translate(-0.063 -0.188)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_112",
    "data-name": "\\u30D1\\u30B9 112",
    d: "M27.869,21.659c-7.725-5.034-15.381-5.047-21.091,4.52a11.38,11.38,0,0,0,21.091-4.52Z",
    transform: "translate(-0.063 -0.188)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_113",
    "data-name": "\\u30D1\\u30B9 113",
    d: "M18.29,24.96c-2.322-2.767,1.206-4.881,1.529-6.629s.02-3.652-3.185-3.652-2.989-3.053,0-3.053a8.69,8.69,0,0,1,8.694,8.686c0,6.172-4.715,7.416-7.037,4.649",
    transform: "translate(-0.134 -0.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_114",
    "data-name": "\\u30D1\\u30B9 114",
    d: "M18.29,24.96c-2.322-2.767,1.206-4.881,1.529-6.629s.02-3.652-3.185-3.652-2.989-3.053,0-3.053a8.69,8.69,0,0,1,8.694,8.686C25.328,26.483,20.612,27.728,18.29,24.96Z",
    transform: "translate(-0.134 -0.119)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_115",
    "data-name": "\\u30D1\\u30B9 115",
    d: "M65.724,27.045S58.1,35.274,57.39,36.112a7.6,7.6,0,0,1-1.467,1.331L54.9,34.236Z",
    transform: "translate(-0.514 -0.278)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_116",
    "data-name": "\\u30D1\\u30B9 116",
    d: "M65.724,27.045S58.1,35.274,57.39,36.112a7.6,7.6,0,0,1-1.467,1.331L54.9,34.236Z",
    transform: "translate(-0.514 -0.278)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_117",
    "data-name": "\\u30D1\\u30B9 117",
    d: "M29.921,21.182c-1.323-4.223-7.631-2.8-6.477,1.749a5.911,5.911,0,0,1-3.593,7.214c-3.8,1.558-2.427,4.4,2.181,4.115,9.067-.567,13.542,4.979,7.888-13.078",
    transform: "translate(-0.165 -0.192)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_118",
    "data-name": "\\u30D1\\u30B9 118",
    d: "M29.921,21.182c-1.323-4.223-7.631-2.8-6.477,1.749a5.911,5.911,0,0,1-3.593,7.214c-3.8,1.558-2.427,4.4,2.181,4.115C31.1,33.693,35.575,39.239,29.921,21.182Z",
    transform: "translate(-0.165 -0.192)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_119",
    "data-name": "\\u30D1\\u30B9 119",
    d: "M34.269,23.571C32.746,23.3,31,21.333,30.2,19.89a.947.947,0,0,0-1.689.855l.89,1.948L23.29,21.487a.88.88,0,0,0-1.037.7l-.031.169a.879.879,0,0,0,.638,1.009l5.3,1.419L22,23.866a.88.88,0,0,0-1.007.785l0,.018a.88.88,0,0,0,.678.942l6.064,1.41-5.874-.713a.881.881,0,0,0-.988.868v.012a.881.881,0,0,0,.709.87l5.887,1.171-4.016-.15a.88.88,0,0,0-.118,1.756c1.977.19,7.32.721,9.733,1.143Z",
    transform: "translate(-0.195 -0.199)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_120",
    "data-name": "\\u30D1\\u30B9 120",
    d: "M34.269,23.571C32.746,23.3,31,21.333,30.2,19.89a.947.947,0,0,0-1.689.855l.89,1.948L23.29,21.487a.88.88,0,0,0-1.037.7l-.031.169a.879.879,0,0,0,.638,1.009l5.3,1.419L22,23.866a.88.88,0,0,0-1.007.785l0,.018a.88.88,0,0,0,.678.942l6.064,1.41-5.874-.713a.881.881,0,0,0-.988.868v.012a.881.881,0,0,0,.709.87l5.887,1.171-4.016-.15a.88.88,0,0,0-.118,1.756c1.977.19,7.32.721,9.733,1.143Z",
    transform: "translate(-0.195 -0.199)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_121",
    "data-name": "\\u30D1\\u30B9 121",
    d: "M58.453,19.038l-7.347,7.541L34.385,23.566l-1.2,8.407,18.067,3.487a7.411,7.411,0,0,0,6.2-1.632l8.068-6.866",
    transform: "translate(-0.311 -0.196)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_122",
    "data-name": "\\u30D1\\u30B9 122",
    d: "M58.453,19.038l-7.347,7.541L34.385,23.566l-1.2,8.407,18.067,3.487a7.411,7.411,0,0,0,6.2-1.632l8.068-6.866",
    transform: "translate(-0.311 -0.196)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_123",
    "data-name": "\\u30D1\\u30B9 123",
    d: "M16.556,48.226A11.379,11.379,0,0,0,5.925,55.539H27.186a11.379,11.379,0,0,0-10.631-7.313",
    transform: "translate(-0.055 -0.496)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_124",
    "data-name": "\\u30D1\\u30B9 124",
    d: "M16.556,48.226A11.379,11.379,0,0,0,5.925,55.539H27.186A11.379,11.379,0,0,0,16.556,48.226Z",
    transform: "translate(-0.055 -0.496)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_125",
    "data-name": "\\u30D1\\u30B9 125",
    d: "M5.918,55.615a11.378,11.378,0,1,0,21.261,0Z",
    transform: "translate(-0.048 -0.572)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_126",
    "data-name": "\\u30D1\\u30B9 126",
    d: "M5.918,55.615a11.378,11.378,0,1,0,21.261,0Z",
    transform: "translate(-0.048 -0.572)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_127",
    "data-name": "\\u30D1\\u30B9 127",
    d: "M92.016,66.823v11.47H96.21a3.1,3.1,0,0,1-3.077-2.707Z",
    transform: "translate(-0.862 -0.688)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_128",
    "data-name": "\\u30D1\\u30B9 128",
    d: "M92.016,66.823v11.47H96.21a3.1,3.1,0,0,1-3.077-2.707Z",
    transform: "translate(-0.862 -0.688)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_129",
    "data-name": "\\u30D1\\u30B9 129",
    d: "M56.339,51.544c-2.041,0,0,2.818,0,5.4Z",
    transform: "translate(-0.519 -0.53)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_130",
    "data-name": "\\u30D1\\u30B9 130",
    d: "M56.339,51.544c-2.041,0,0,2.818,0,5.4Z",
    transform: "translate(-0.519 -0.53)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_131",
    "data-name": "\\u30D1\\u30B9 131",
    d: "M62.637,10.437A6.577,6.577,0,0,0,50.882,6.385C52.2,8.031,56.4,8.676,58.3,8.331c.442,3.344,2.735,3.553,4.151,3.634a6.526,6.526,0,0,0,.186-1.528",
    transform: "translate(-0.476 -0.039)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_132",
    "data-name": "\\u30D1\\u30B9 132",
    d: "M62.637,10.437A6.577,6.577,0,0,0,50.882,6.385C52.2,8.031,56.4,8.676,58.3,8.331c.442,3.344,2.735,3.553,4.151,3.634A6.526,6.526,0,0,0,62.637,10.437Z",
    transform: "translate(-0.476 -0.039)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_133",
    "data-name": "\\u30D1\\u30B9 133",
    d: "M18.17,66.292c-2.33-2.775,1.209-4.9,1.533-6.65s.02-3.663-3.194-3.663-3-3.062,0-3.062a8.716,8.716,0,0,1,8.72,8.712c0,6.191-4.729,7.438-7.058,4.663",
    transform: "translate(-0.133 -0.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_134",
    "data-name": "\\u30D1\\u30B9 134",
    d: "M18.17,66.292c-2.33-2.775,1.209-4.9,1.533-6.65s.02-3.663-3.194-3.663-3-3.062,0-3.062a8.716,8.716,0,0,1,8.72,8.712C25.229,67.82,20.5,69.067,18.17,66.292Z",
    transform: "translate(-0.133 -0.545)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_135",
    "data-name": "\\u30D1\\u30B9 135",
    d: "M51.592,11.228l-.411.934a.514.514,0,0,0,.471.721h.907",
    transform: "translate(-0.479 -0.115)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_136",
    "data-name": "\\u30D1\\u30B9 136",
    d: "M51.592,11.228l-.411.934a.514.514,0,0,0,.471.721h.907",
    transform: "translate(-0.479 -0.115)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3",
    transform: "translate(-61 488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3-2",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4_call-image2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_396",
    "data-name": "\\u30D1\\u30B9 396",
    d: "M67.144,24.781A12.024,12.024,0,1,0,55.119,36.8,12.021,12.021,0,0,0,67.144,24.781",
    transform: "translate(7.541 2.225)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_15",
    "data-name": "\\u6955\\u5186\\u5F62 15",
    cx: 12.024,
    cy: 12.017,
    rx: 12.024,
    ry: 12.017,
    transform: "translate(50.638 14.989)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_397",
    "data-name": "\\u30D1\\u30B9 397",
    d: "M67.144,24.781A12.024,12.024,0,1,0,55.119,36.8,12.021,12.021,0,0,0,67.144,24.781",
    transform: "translate(7.541 2.225)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_16",
    "data-name": "\\u6955\\u5186\\u5F62 16",
    cx: 12.024,
    cy: 12.017,
    rx: 12.024,
    ry: 12.017,
    transform: "translate(50.638 14.989)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_398",
    "data-name": "\\u30D1\\u30B9 398",
    d: "M106.883,24.781A12.024,12.024,0,1,0,94.86,36.8a12.02,12.02,0,0,0,12.024-12.017",
    transform: "translate(14.495 2.225)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_17",
    "data-name": "\\u6955\\u5186\\u5F62 17",
    cx: 12.024,
    cy: 12.017,
    rx: 12.024,
    ry: 12.017,
    transform: "translate(97.331 14.989)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_399",
    "data-name": "\\u30D1\\u30B9 399",
    d: "M3.854,84.229H168.047a3.569,3.569,0,1,0,0-7.138H3.854a3.569,3.569,0,1,0,0,7.138",
    transform: "translate(0.05 13.439)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_400",
    "data-name": "\\u30D1\\u30B9 400",
    d: "M3.854,84.229H168.047a3.569,3.569,0,1,0,0-7.138H3.854a3.569,3.569,0,1,0,0,7.138Z",
    transform: "translate(0.05 13.439)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_401",
    "data-name": "\\u30D1\\u30B9 401",
    d: "M100.865,22.15c-1.529.073-3.641-1.432-4.741-2.642a.937.937,0,0,0-1.437,1.2l1.29,1.679-6.149.193a.87.87,0,0,0-.842.909l.007.169a.872.872,0,0,0,.839.831l5.423.19-6.14.478a.87.87,0,0,0-.8.981v.018a.872.872,0,0,0,.862.757l6.152.013-5.815.618a.869.869,0,0,0-.758,1.055l0,.012a.869.869,0,0,0,.875.68l5.93-.179-3.9.747a.871.871,0,0,0,.277,1.718c1.947-.256,7.21-.929,9.628-1.058Z",
    transform: "translate(15.453 3.347)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_402",
    "data-name": "\\u30D1\\u30B9 402",
    d: "M100.865,22.15c-1.529.073-3.641-1.432-4.741-2.642a.937.937,0,0,0-1.437,1.2l1.29,1.679-6.149.193a.87.87,0,0,0-.842.909l.007.169a.872.872,0,0,0,.839.831l5.423.19-6.14.478a.87.87,0,0,0-.8.981v.018a.872.872,0,0,0,.862.757l6.152.013-5.815.618a.869.869,0,0,0-.758,1.055l0,.012a.869.869,0,0,0,.875.68l5.93-.179-3.9.747a.871.871,0,0,0,.277,1.718c1.947-.256,7.21-.929,9.628-1.058Z",
    transform: "translate(15.453 3.347)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_403",
    "data-name": "\\u30D1\\u30B9 403",
    d: "M122.571,14.261a22.605,22.605,0,0,1-8.386,6.592C109.078,23.211,99,23.011,99,23.011l.709,8.366c15.238-.124,24.31-3.081,28.849-9.195",
    transform: "translate(17.323 2.486)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_404",
    "data-name": "\\u30D1\\u30B9 404",
    d: "M122.571,14.261a22.605,22.605,0,0,1-8.386,6.592C109.078,23.211,99,23.011,99,23.011l.709,8.366c15.238-.124,24.31-3.081,28.849-9.195",
    transform: "translate(17.323 2.486)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_405",
    "data-name": "\\u30D1\\u30B9 405",
    d: "M106.316,45.351V24.893a13.05,13.05,0,0,1,13.015-13.008h.295a12.241,12.241,0,0,1,11.99,10.363,9.506,9.506,0,0,0,2.969,5.605,8.735,8.735,0,0,1,3.667,6.44c.392,2.218,1.229,4.054,4.389,4.667a3.228,3.228,0,0,1-.649,6.391Z",
    transform: "translate(18.604 2.072)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_406",
    "data-name": "\\u30D1\\u30B9 406",
    d: "M106.316,45.351V24.893a13.05,13.05,0,0,1,13.015-13.008h.295a12.241,12.241,0,0,1,11.99,10.363,9.506,9.506,0,0,0,2.969,5.605,8.735,8.735,0,0,1,3.667,6.44c.392,2.218,1.229,4.054,4.389,4.667a3.228,3.228,0,0,1-.649,6.391Z",
    transform: "translate(18.604 2.072)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_407",
    "data-name": "\\u30D1\\u30B9 407",
    d: "M113.415,9.951v4.743c0,3.141,7.33,2.963,7.33-.393V9.951Z",
    transform: "translate(19.846 1.734)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_408",
    "data-name": "\\u30D1\\u30B9 408",
    d: "M113.415,9.951v4.743c0,3.141,7.33,2.963,7.33-.393V9.951Z",
    transform: "translate(19.846 1.734)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_409",
    "data-name": "\\u30D1\\u30B9 409",
    d: "M119.993,15a7.633,7.633,0,1,0-2.587.528",
    transform: "translate(19.172 0.049)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_410",
    "data-name": "\\u30D1\\u30B9 410",
    d: "M119.993,15a7.633,7.633,0,1,0-2.587.528",
    transform: "translate(19.172 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_12",
    "data-name": "\\u7DDA 12",
    x1: 1.406,
    y2: 0.04,
    transform: "translate(130.662 8.491)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_411",
    "data-name": "\\u30D1\\u30B9 411",
    d: "M110.014,5.9h0a1.627,1.627,0,1,0,1.673,1.579A1.632,1.632,0,0,0,110.014,5.9Z",
    transform: "translate(18.974 1.029)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_412",
    "data-name": "\\u30D1\\u30B9 412",
    d: "M113.98,5.791h0a1.627,1.627,0,1,0,1.673,1.579A1.632,1.632,0,0,0,113.98,5.791Z",
    transform: "translate(19.668 1.009)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_413",
    "data-name": "\\u30D1\\u30B9 413",
    d: "M112.614,9.511l-1.2.034a.5.5,0,0,1-.5-.594l.338-1.684.542-.015",
    transform: "translate(19.406 1.264)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_414",
    "data-name": "\\u30D1\\u30B9 414",
    d: "M112.614,9.511l-1.2.034a.5.5,0,0,1-.5-.594l.338-1.684.542-.015",
    transform: "translate(19.406 1.264)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_415",
    "data-name": "\\u30D1\\u30B9 415",
    d: "M117.33,13.316a8.837,8.837,0,0,1-3.916-.058v-.494a8.071,8.071,0,0,0,3.916.552",
    transform: "translate(19.846 2.225)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_416",
    "data-name": "\\u30D1\\u30B9 416",
    d: "M117.33,13.316a8.837,8.837,0,0,1-3.916-.058v-.494A8.071,8.071,0,0,0,117.33,13.316Z",
    transform: "translate(19.846 2.225)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_417",
    "data-name": "\\u30D1\\u30B9 417",
    d: "M120.927,40.383c.437,4-1.7,7.054-3.565,9.349V45.057Z",
    transform: "translate(20.536 7.04)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_418",
    "data-name": "\\u30D1\\u30B9 418",
    d: "M120.927,40.383c.437,4-1.7,7.054-3.565,9.349V45.057Z",
    transform: "translate(20.536 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_419",
    "data-name": "\\u30D1\\u30B9 419",
    d: "M93.778,78.442h0a2.836,2.836,0,0,1,2.838-2.836h4.008v-2.34h12.159v8.012H96.616a2.836,2.836,0,0,1-2.838-2.836",
    transform: "translate(16.41 12.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_420",
    "data-name": "\\u30D1\\u30B9 420",
    d: "M93.778,78.442h0a2.836,2.836,0,0,1,2.838-2.836h4.008v-2.34h12.159v8.012H96.616A2.836,2.836,0,0,1,93.778,78.442Z",
    transform: "translate(16.41 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_421",
    "data-name": "\\u30D1\\u30B9 421",
    d: "M124.035,40.383H107.491l-5.8,8.806A12.645,12.645,0,0,0,99.6,56.146V79h12.159V55.414c8.708-6.958,12.273-11.38,12.273-15.031",
    transform: "translate(17.429 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_422",
    "data-name": "\\u30D1\\u30B9 422",
    d: "M124.035,40.383H107.491l-5.8,8.806A12.645,12.645,0,0,0,99.6,56.146V79h12.159V55.414C120.47,48.457,124.035,44.034,124.035,40.383Z",
    transform: "translate(17.429 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_423",
    "data-name": "\\u30D1\\u30B9 423",
    d: "M99.6,73.267h12.159V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(17.429 12.772)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_424",
    "data-name": "\\u30D1\\u30B9 424",
    d: "M99.6,73.267h12.159V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(17.429 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_425",
    "data-name": "\\u30D1\\u30B9 425",
    d: "M50.539,78.442h0A2.836,2.836,0,0,0,47.7,75.606H43.694v-2.34H31.535v8.012H47.7a2.836,2.836,0,0,0,2.838-2.836",
    transform: "translate(5.518 12.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_426",
    "data-name": "\\u30D1\\u30B9 426",
    d: "M50.539,78.442h0A2.836,2.836,0,0,0,47.7,75.606H43.694v-2.34H31.535v8.012H47.7A2.836,2.836,0,0,0,50.539,78.442Z",
    transform: "translate(5.518 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_427",
    "data-name": "\\u30D1\\u30B9 427",
    d: "M32.978,78.442h0a2.836,2.836,0,0,0-2.838-2.836H26.133v-2.34H13.974v8.012H30.141a2.836,2.836,0,0,0,2.838-2.836",
    transform: "translate(2.445 12.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_428",
    "data-name": "\\u30D1\\u30B9 428",
    d: "M32.978,78.442h0a2.836,2.836,0,0,0-2.838-2.836H26.133v-2.34H13.974v8.012H30.141A2.836,2.836,0,0,0,32.978,78.442Z",
    transform: "translate(2.445 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_429",
    "data-name": "\\u30D1\\u30B9 429",
    d: "M21.09,40.383H37.634l5.8,8.806a12.645,12.645,0,0,1,2.086,6.957V79H33.363V55.414C24.655,48.457,21.09,44.034,21.09,40.383",
    transform: "translate(3.69 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_430",
    "data-name": "\\u30D1\\u30B9 430",
    d: "M21.09,40.383H37.634l5.8,8.806a12.645,12.645,0,0,1,2.086,6.957V79H33.363V55.414C24.655,48.457,21.09,44.034,21.09,40.383Z",
    transform: "translate(3.69 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_431",
    "data-name": "\\u30D1\\u30B9 431",
    d: "M31.535,73.267H43.694V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(5.518 12.772)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_432",
    "data-name": "\\u30D1\\u30B9 432",
    d: "M31.535,73.267H43.694V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(5.518 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_433",
    "data-name": "\\u30D1\\u30B9 433",
    d: "M131.47,82.093h0a3.22,3.22,0,0,1-.283-4.558l2.395-2.7-1.752-1.552,8.067-9.092L146.49,70,136.013,81.811a3.226,3.226,0,0,1-4.542.282",
    transform: "translate(22.813 11.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_434",
    "data-name": "\\u30D1\\u30B9 434",
    d: "M131.47,82.093h0a3.22,3.22,0,0,1-.283-4.558l2.395-2.7-1.752-1.552,8.067-9.092L146.49,70,136.013,81.811A3.226,3.226,0,0,1,131.47,82.093Z",
    transform: "translate(22.813 11.19)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_435",
    "data-name": "\\u30D1\\u30B9 435",
    d: "M134.106,77.435,120.089,63.146a9.533,9.533,0,0,1-2.727-6.674V40.383h12.16V56.361l12.651,11.983Z",
    transform: "translate(20.536 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_436",
    "data-name": "\\u30D1\\u30B9 436",
    d: "M134.106,77.435,120.089,63.146a9.533,9.533,0,0,1-2.727-6.674V40.383h12.16V56.361l12.651,11.983Z",
    transform: "translate(20.536 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_437",
    "data-name": "\\u30D1\\u30B9 437",
    d: "M116.719.286a7.6,7.6,0,0,0-5.7,2.825c3.2,2.68,8.192,3.586,8.192,3.586-.867,3.469-.466,6.218,2.572,7.094A7.62,7.62,0,0,0,116.719.286",
    transform: "translate(19.426 0.049)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_438",
    "data-name": "\\u30D1\\u30B9 438",
    d: "M116.719.286a7.6,7.6,0,0,0-5.7,2.825c3.2,2.68,8.192,3.586,8.192,3.586-.867,3.469-.466,6.218,2.572,7.094A7.62,7.62,0,0,0,116.719.286Z",
    transform: "translate(19.426 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_439",
    "data-name": "\\u30D1\\u30B9 439",
    d: "M26.308,79V40.383H12.973L14.149,79Z",
    transform: "translate(2.27 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_440",
    "data-name": "\\u30D1\\u30B9 440",
    d: "M26.308,79V40.383H12.973L14.149,79Z",
    transform: "translate(2.27 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_441",
    "data-name": "\\u30D1\\u30B9 441",
    d: "M49.436,22.747c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L54.277,23.46l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L60.2,29.224a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125A.87.87,0,0,1,57.39,33c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(8.384 3.545)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_442",
    "data-name": "\\u30D1\\u30B9 442",
    d: "M49.436,22.747c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L54.277,23.46l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L60.2,29.224a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125A.87.87,0,0,1,57.39,33c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(8.384 3.545)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_443",
    "data-name": "\\u30D1\\u30B9 443",
    d: "M32.172,14.482a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C36.9,30.409,28.162,26.579,24.243,20.051",
    transform: "translate(4.242 2.524)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_444",
    "data-name": "\\u30D1\\u30B9 444",
    d: "M32.172,14.482a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C36.9,30.409,28.162,26.579,24.243,20.051",
    transform: "translate(4.242 2.524)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_445",
    "data-name": "\\u30D1\\u30B9 445",
    d: "M12.973,25.349v24.04h9.356a36.6,36.6,0,0,0,16.726-4.044v-20A13.243,13.243,0,0,0,26.014,11.915,13.242,13.242,0,0,0,12.973,25.349",
    transform: "translate(2.27 2.077)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_446",
    "data-name": "\\u30D1\\u30B9 446",
    d: "M12.973,25.349v24.04h9.356a36.6,36.6,0,0,0,16.726-4.044v-20A13.243,13.243,0,0,0,26.014,11.915,13.242,13.242,0,0,0,12.973,25.349Z",
    transform: "translate(2.27 2.077)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_447",
    "data-name": "\\u30D1\\u30B9 447",
    d: "M28.506,9.951v4.743c0,3.141-7.33,2.963-7.33-.393V9.951Z",
    transform: "translate(3.705 1.734)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_448",
    "data-name": "\\u30D1\\u30B9 448",
    d: "M28.506,9.951v4.743c0,3.141-7.33,2.963-7.33-.393V9.951Z",
    transform: "translate(3.705 1.734)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_449",
    "data-name": "\\u30D1\\u30B9 449",
    d: "M23.107,15a7.633,7.633,0,1,1,2.587.528",
    transform: "translate(3.199 0.049)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_450",
    "data-name": "\\u30D1\\u30B9 450",
    d: "M23.107,15a7.633,7.633,0,1,1,2.587.528",
    transform: "translate(3.199 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_13",
    "data-name": "\\u7DDA 13",
    x2: 1.406,
    y2: 0.04,
    transform: "translate(33.403 8.491)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_451",
    "data-name": "\\u30D1\\u30B9 451",
    d: "M31.3,5.9h0a1.627,1.627,0,1,1-1.673,1.579A1.632,1.632,0,0,1,31.3,5.9Z",
    transform: "translate(5.184 1.029)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_452",
    "data-name": "\\u30D1\\u30B9 452",
    d: "M27.332,5.791h0a1.627,1.627,0,1,1-1.673,1.579A1.632,1.632,0,0,1,27.332,5.791Z",
    transform: "translate(4.49 1.009)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_453",
    "data-name": "\\u30D1\\u30B9 453",
    d: "M28.47,9.511l1.2.034a.5.5,0,0,0,.5-.594l-.338-1.684-.542-.015",
    transform: "translate(4.982 1.264)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_454",
    "data-name": "\\u30D1\\u30B9 454",
    d: "M28.47,9.511l1.2.034a.5.5,0,0,0,.5-.594l-.338-1.684-.542-.015",
    transform: "translate(4.982 1.264)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_455",
    "data-name": "\\u30D1\\u30B9 455",
    d: "M24.082,13.316A8.837,8.837,0,0,0,28,13.258v-.494a8.071,8.071,0,0,1-3.916.552",
    transform: "translate(4.214 2.225)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_456",
    "data-name": "\\u30D1\\u30B9 456",
    d: "M24.082,13.316A8.837,8.837,0,0,0,28,13.258v-.494A8.071,8.071,0,0,1,24.082,13.316Z",
    transform: "translate(4.214 2.225)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_457",
    "data-name": "\\u30D1\\u30B9 457",
    d: "M19.538,7.689a7.77,7.77,0,0,1,7.841-7.4,7.6,7.6,0,0,1,5.7,2.825c-3.2,2.68-8.192,3.588-8.192,3.588.867,3.469.979,6.863-2.06,7.739-5.692,2.259-9.479,7.581-9.479,12.94-4.391-6.227-1.2-10.019.583-11.693s1.69-3.934,3.2-5.033,2.262-1.258,2.4-2.963",
    transform: "translate(1.949 0.049)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_458",
    "data-name": "\\u30D1\\u30B9 458",
    d: "M19.538,7.689a7.77,7.77,0,0,1,7.841-7.4,7.6,7.6,0,0,1,5.7,2.825c-3.2,2.68-8.192,3.588-8.192,3.588.867,3.469.979,6.863-2.06,7.739-5.692,2.259-9.479,7.581-9.479,12.94-4.391-6.227-1.2-10.019.583-11.693s1.69-3.934,3.2-5.033S19.4,9.395,19.538,7.689Z",
    transform: "translate(1.949 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_459",
    "data-name": "\\u30D1\\u30B9 459",
    d: "M59.542,22.455C56.851,24.71,54.8,21.284,53.1,20.971s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439c6,0,7.211,4.576,4.52,6.831",
    transform: "translate(8.15 2.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_460",
    "data-name": "\\u30D1\\u30B9 460",
    d: "M59.542,22.455C56.851,24.71,54.8,21.284,53.1,20.971s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439C61.022,15.624,62.232,20.2,59.542,22.455Z",
    transform: "translate(8.15 2.723)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_461",
    "data-name": "\\u30D1\\u30B9 461",
    d: "M99.133,22.455c-2.691,2.255-4.746-1.171-6.445-1.484s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439c6,0,7.211,4.576,4.52,6.831",
    transform: "translate(15.078 2.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_462",
    "data-name": "\\u30D1\\u30B9 462",
    d: "M99.133,22.455c-2.691,2.255-4.746-1.171-6.445-1.484s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439C100.613,15.624,101.823,20.2,99.133,22.455Z",
    transform: "translate(15.078 2.723)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_463",
    "data-name": "\\u30D1\\u30B9 463",
    d: "M94.715,13.405a11.045,11.045,0,1,0,11.052,11.046A11.048,11.048,0,0,0,94.715,13.405Z",
    transform: "translate(14.64 2.337)",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_464",
    "data-name": "\\u30D1\\u30B9 464",
    d: "M114.291,19.637a5.549,5.549,0,0,1-4.746-2.653,15.757,15.757,0,0,0-25.912-1.494,5.363,5.363,0,0,1-4.228,2.081H75.9v6.151h4.492c-.042.47-.068.944-.068,1.424a15.755,15.755,0,0,0,31.47,1.118q.025-.359.033-.715a.973.973,0,0,1,.969-.955h1.5a1.135,1.135,0,0,0,1.135-1.134V20.772a1.134,1.134,0,0,0-1.135-1.134M96.074,36.193a11.045,11.045,0,1,1,11.052-11.046A11.049,11.049,0,0,1,96.074,36.193",
    transform: "translate(13.281 1.639)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_465",
    "data-name": "\\u30D1\\u30B9 465",
    d: "M114.291,19.637a5.549,5.549,0,0,1-4.746-2.653,15.757,15.757,0,0,0-25.912-1.494,5.363,5.363,0,0,1-4.228,2.081H75.9v6.151h4.492c-.042.47-.068.944-.068,1.424a15.755,15.755,0,0,0,31.47,1.118q.025-.359.033-.715a.973.973,0,0,1,.969-.955h1.5a1.135,1.135,0,0,0,1.135-1.134V20.772A1.134,1.134,0,0,0,114.291,19.637ZM96.074,36.193a11.045,11.045,0,1,1,11.052-11.046A11.049,11.049,0,0,1,96.074,36.193Z",
    transform: "translate(13.281 1.639)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_466",
    "data-name": "\\u30D1\\u30B9 466",
    d: "M73.315,17.572a5.306,5.306,0,0,1-4.2-2.047,15.741,15.741,0,0,0-25.9,1.414,5.545,5.545,0,0,1-4.7,2.7h-.094a1.135,1.135,0,0,0-1.135,1.134v2.689A1.136,1.136,0,0,0,38.423,24.6h1.513a.965.965,0,0,1,.967.938,15.751,15.751,0,0,0,31.5-.386c0-.48-.026-.955-.067-1.424h3.222a4.33,4.33,0,0,0,0-6.151ZM56.647,36.193A11.045,11.045,0,1,1,67.7,25.147,11.048,11.048,0,0,1,56.647,36.193",
    transform: "translate(6.525 1.639)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_467",
    "data-name": "\\u30D1\\u30B9 467",
    d: "M73.315,17.572a5.306,5.306,0,0,1-4.2-2.047,15.741,15.741,0,0,0-25.9,1.414,5.545,5.545,0,0,1-4.7,2.7h-.094a1.135,1.135,0,0,0-1.135,1.134v2.689A1.136,1.136,0,0,0,38.423,24.6h1.513a.965.965,0,0,1,.967.938,15.751,15.751,0,0,0,31.5-.386c0-.48-.026-.955-.067-1.424h3.222a4.33,4.33,0,0,0,0-6.151ZM56.647,36.193A11.045,11.045,0,1,1,67.7,25.147,11.048,11.048,0,0,1,56.647,36.193Z",
    transform: "translate(6.525 1.639)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_468",
    "data-name": "\\u30D1\\u30B9 468",
    d: "M100.795,27.563c-1.513.222-3.765-1.067-4.977-2.165a.936.936,0,0,0-1.312,1.334l1.449,1.544-6.1.794a.871.871,0,0,0-.75.986l.025.169a.87.87,0,0,0,.916.745l5.414-.342-6.065,1.077a.871.871,0,0,0-.7,1.053l0,.018a.87.87,0,0,0,.931.669l6.125-.59L90.032,34.04a.87.87,0,0,0-.651,1.124l0,.012a.871.871,0,0,0,.939.592l5.884-.759L92.4,36.134a.87.87,0,0,0,.443,1.683c1.913-.446,7.084-1.631,9.479-2Z",
    transform: "translate(15.517 4.385)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_469",
    "data-name": "\\u30D1\\u30B9 469",
    d: "M100.795,27.563c-1.513.222-3.765-1.067-4.977-2.165a.936.936,0,0,0-1.312,1.334l1.449,1.544-6.1.794a.871.871,0,0,0-.75.986l.025.169a.87.87,0,0,0,.916.745l5.414-.342-6.065,1.077a.871.871,0,0,0-.7,1.053l0,.018a.87.87,0,0,0,.931.669l6.125-.59L90.032,34.04a.87.87,0,0,0-.651,1.124l0,.012a.871.871,0,0,0,.939.592l5.884-.759L92.4,36.134a.87.87,0,0,0,.443,1.683c1.913-.446,7.084-1.631,9.479-2Z",
    transform: "translate(15.517 4.385)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_470",
    "data-name": "\\u30D1\\u30B9 470",
    d: "M121.6,17.826a22.588,22.588,0,0,1-7.7,7.381c-4.852,2.847-14.906,3.635-14.906,3.635l1.525,8.257c15.153-1.616,23.891-5.447,27.81-11.975",
    transform: "translate(17.322 3.107)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_471",
    "data-name": "\\u30D1\\u30B9 471",
    d: "M121.6,17.826a22.588,22.588,0,0,1-7.7,7.381c-4.852,2.847-14.906,3.635-14.906,3.635l1.525,8.257c15.153-1.616,23.891-5.447,27.81-11.975",
    transform: "translate(17.322 3.107)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_472",
    "data-name": "\\u30D1\\u30B9 472",
    d: "M41.439,26.091c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L46.28,26.8l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L52.2,32.568a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125a.87.87,0,0,1-.443,1.683c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(6.984 4.128)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_473",
    "data-name": "\\u30D1\\u30B9 473",
    d: "M41.439,26.091c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L46.28,26.8l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L52.2,32.568a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125a.87.87,0,0,1-.443,1.683c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(6.984 4.128)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_474",
    "data-name": "\\u30D1\\u30B9 474",
    d: "M24.175,17.826a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C28.9,33.753,20.165,29.923,16.246,23.395",
    transform: "translate(2.843 3.107)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_475",
    "data-name": "\\u30D1\\u30B9 475",
    d: "M24.175,17.826a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C28.9,33.753,20.165,29.923,16.246,23.395",
    transform: "translate(2.843 3.107)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_476",
    "data-name": "\\u30D1\\u30B9 476",
    d: "M74.5,19.436c0,1.7.713,3.076,1.594,3.076s1.593-1.377,1.593-3.076S76.978,16.36,76.1,16.36,74.5,17.737,74.5,19.436",
    transform: "translate(13.037 2.852)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_477",
    "data-name": "\\u30D1\\u30B9 477",
    d: "M74.5,19.436c0,1.7.713,3.076,1.594,3.076s1.593-1.377,1.593-3.076S76.978,16.36,76.1,16.36,74.5,17.737,74.5,19.436Z",
    transform: "translate(13.037 2.852)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_478",
    "data-name": "\\u30D1\\u30B9 478",
    d: "M67.967,12.967a5.291,5.291,0,0,0-5.3,5.292,5.29,5.29,0,0,0-5.294-5.292,5.291,5.291,0,0,0,5.3-5.292,5.29,5.29,0,0,0,5.294,5.292",
    transform: "translate(10.04 1.338)",
    fill: "#fff",
    stroke: "#1a1311",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_479",
    "data-name": "\\u30D1\\u30B9 479",
    d: "M87.107,32.264a3.714,3.714,0,0,0-3.718,3.716,3.714,3.714,0,0,0-3.718-3.716,3.714,3.714,0,0,0,3.718-3.716,3.714,3.714,0,0,0,3.718,3.716",
    transform: "translate(13.941 4.976)",
    fill: "#fff",
    stroke: "#1a1311",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_480",
    "data-name": "\\u30D1\\u30B9 480",
    d: "M91.1,11.944a3.714,3.714,0,0,0-3.718,3.716,3.714,3.714,0,0,0-3.718-3.716,3.714,3.714,0,0,0,3.718-3.716A3.714,3.714,0,0,0,91.1,11.944",
    transform: "translate(14.64 1.434)",
    fill: "#fff",
    stroke: "#1a1311",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_481",
    "data-name": "\\u30D1\\u30B9 481",
    d: "M106.316,40.383H119.3v1.389Z",
    transform: "translate(18.604 7.04)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_482",
    "data-name": "\\u30D1\\u30B9 482",
    d: "M106.316,40.383H119.3v1.389Z",
    transform: "translate(18.604 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }))), /*#__PURE__*/React.createElement("g", {
    id: "illust-2",
    "data-name": "illust",
    transform: "translate(273.704 483.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_137",
    "data-name": "\\u30D1\\u30B9 137",
    d: "M99.448,4.679a4.407,4.407,0,1,0,4.407-4.4,4.4,4.4,0,0,0-4.407,4.4",
    transform: "translate(4.408 -0.234)",
    fill: "#f9b137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_138",
    "data-name": "\\u30D1\\u30B9 138",
    d: "M99.448,4.679a4.407,4.407,0,1,0,4.407-4.4A4.4,4.4,0,0,0,99.448,4.679Z",
    transform: "translate(4.408 -0.234)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_139",
    "data-name": "\\u30D1\\u30B9 139",
    d: "M6.354,98.818H112.149a3.159,3.159,0,0,0,3.154-3.146V95.01a3.159,3.159,0,0,0-3.154-3.146H6.354A3.159,3.159,0,0,0,3.2,95.01v.662a3.159,3.159,0,0,0,3.154,3.146",
    transform: "translate(0.142 3.593)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_7",
    "data-name": "\\u9577\\u65B9\\u5F62 7",
    width: 112.102,
    height: 6.954,
    rx: 3,
    transform: "translate(3.342 95.457)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_140",
    "data-name": "\\u30D1\\u30B9 140",
    d: "M78.762,49.4,60.7,67.569V88.83h-12.6V65.905a10.331,10.331,0,0,1,2.579-6.828l8.52-9.676Z",
    transform: "translate(2.133 1.819)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_141",
    "data-name": "\\u30D1\\u30B9 141",
    d: "M78.762,49.4,60.7,67.569V88.83h-12.6V65.905a10.331,10.331,0,0,1,2.579-6.828l8.52-9.676Z",
    transform: "translate(2.133 1.819)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_142",
    "data-name": "\\u30D1\\u30B9 142",
    d: "M41.313,92.6h0a2.936,2.936,0,0,1,2.94-2.933h4.153v-2.42H61v8.285H44.253a2.936,2.936,0,0,1-2.94-2.933",
    transform: "translate(1.831 3.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_143",
    "data-name": "\\u30D1\\u30B9 143",
    d: "M41.313,92.6h0a2.936,2.936,0,0,1,2.94-2.933h4.153v-2.42H61v8.285H44.253A2.936,2.936,0,0,1,41.313,92.6Z",
    transform: "translate(1.831 3.4)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_144",
    "data-name": "\\u30D1\\u30B9 144",
    d: "M103.646,84.105h0a3.2,3.2,0,0,1-3.2-3.2V77.029H98.017V64.461h8.832V80.91a3.2,3.2,0,0,1-3.2,3.2",
    transform: "translate(4.345 2.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_145",
    "data-name": "\\u30D1\\u30B9 145",
    d: "M103.646,84.105h0a3.2,3.2,0,0,1-3.2-3.2V77.029H98.017V64.461h8.832V80.91A3.2,3.2,0,0,1,103.646,84.105Z",
    transform: "translate(4.345 2.448)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_146",
    "data-name": "\\u30D1\\u30B9 146",
    d: "M69.853,69.436V49.4H84.559L82.166,65.09h17.1V77.656L77.81,77.45a8.024,8.024,0,0,1-7.957-8.014",
    transform: "translate(3.096 1.819)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_147",
    "data-name": "\\u30D1\\u30B9 147",
    d: "M69.853,69.436V49.4H84.559L82.166,65.09h17.1V77.656L77.81,77.45A8.024,8.024,0,0,1,69.853,69.436Z",
    transform: "translate(3.096 1.819)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_148",
    "data-name": "\\u30D1\\u30B9 148",
    d: "M56.46,26.013c-4.517,7.927-11.923,6.117-19.027-1.723L31.69,30.245c9.371,10.4,24.1,12.828,31.239,3.468",
    transform: "translate(1.405 0.769)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_149",
    "data-name": "\\u30D1\\u30B9 149",
    d: "M56.46,26.013c-4.517,7.927-11.923,6.117-19.027-1.723L31.69,30.245c9.371,10.4,24.1,12.828,31.239,3.468",
    transform: "translate(1.405 0.769)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_150",
    "data-name": "\\u30D1\\u30B9 150",
    d: "M101.666,50.657H58.939l-4.332-15.6a12.4,12.4,0,0,1,10.8-15.65h.006a12.634,12.634,0,0,1,12.369,6.979c2.259,4.383,8.617,7.5,13.557,8.618,6.966,1.577,3.874,5.546,11.284,7.412a4.132,4.132,0,0,1,3.156,3.992v.14a4.111,4.111,0,0,1-4.116,4.106",
    transform: "translate(2.4 0.563)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_151",
    "data-name": "\\u30D1\\u30B9 151",
    d: "M101.666,50.657H58.939l-4.332-15.6a12.4,12.4,0,0,1,10.8-15.65h.006a12.634,12.634,0,0,1,12.369,6.979c2.259,4.383,8.617,7.5,13.557,8.618,6.966,1.577,3.874,5.546,11.284,7.412a4.132,4.132,0,0,1,3.156,3.992v.14A4.111,4.111,0,0,1,101.666,50.657Z",
    transform: "translate(2.4 0.563)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_152",
    "data-name": "\\u30D1\\u30B9 152",
    d: "M67.3,19.356c24.621.855,27.045,24.519,5.387,26.073l-2.372-7.983c10.382-.682,9.053-7.348,2.139-8.578",
    transform: "translate(2.983 0.563)",
    fill: "#3fbfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_153",
    "data-name": "\\u30D1\\u30B9 153",
    d: "M67.3,19.356c24.621.855,27.045,24.519,5.387,26.073l-2.372-7.983c10.382-.682,9.053-7.348,2.139-8.578",
    transform: "translate(2.983 0.563)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_154",
    "data-name": "\\u30D1\\u30B9 154",
    d: "M65.373,17.886a6.348,6.348,0,1,0-6.348,6.333,6.341,6.341,0,0,0,6.348-6.333",
    transform: "translate(2.335 0.237)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5",
    "data-name": "\\u6955\\u5186\\u5F62 5",
    cx: 6.348,
    cy: 6.333,
    rx: 6.348,
    ry: 6.333,
    transform: "translate(55.011 11.79)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_155",
    "data-name": "\\u30D1\\u30B9 155",
    d: "M70.064,49.4v7.994l-4.969,5,.639-.642a12.11,12.11,0,0,0,3.353-6.529Z",
    transform: "translate(2.886 1.819)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_156",
    "data-name": "\\u30D1\\u30B9 156",
    d: "M70.064,49.4v7.994l-4.969,5,.639-.642a12.11,12.11,0,0,0,3.353-6.529Z",
    transform: "translate(2.886 1.819)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_157",
    "data-name": "\\u30D1\\u30B9 157",
    d: "M54.15,13.77c2.234,3.087,3.926,4.127,6.727,4.127,6.078,0,2.785,2.944,8.865,2.915a84.844,84.844,0,0,1,10.439.755,2.684,2.684,0,1,0,.642-5.33c-2.931-.317-5.442-.06-7.394-1.489-2.88-2.11-5.021-.264-8.721-2.11S57.334,10.551,54.15,13.77",
    transform: "translate(2.4 0.226)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_158",
    "data-name": "\\u30D1\\u30B9 158",
    d: "M54.15,13.77c2.234,3.087,3.926,4.127,6.727,4.127,6.078,0,2.785,2.944,8.865,2.915a84.844,84.844,0,0,1,10.439.755,2.684,2.684,0,1,0,.642-5.33c-2.931-.317-5.442-.06-7.394-1.489-2.88-2.11-5.021-.264-8.721-2.11S57.334,10.551,54.15,13.77Z",
    transform: "translate(2.4 0.226)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_4",
    "data-name": "\\u7DDA 4",
    x1: 1.458,
    y2: 0.042,
    transform: "translate(57.269 18.416)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8",
    "data-name": "\\u9577\\u65B9\\u5F62 8",
    width: 3.374,
    height: 3.366,
    rx: 0.696,
    transform: "translate(53.849 16.851) rotate(-1.62)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_9",
    "data-name": "\\u9577\\u65B9\\u5F62 9",
    d: "M.7,0H2.679a.695.695,0,0,1,.695.695V2.671a.695.695,0,0,1-.695.695H.695A.695.695,0,0,1,0,2.671V.7A.7.7,0,0,1,.7,0Z",
    transform: "translate(58.679 16.714) rotate(-1.62)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_159",
    "data-name": "\\u30D1\\u30B9 159",
    d: "M26.232,26.11c1.205.905,3.953,4.8,6.272,4.589l5.467-6.117a20.7,20.7,0,0,0-6.55-3.71",
    transform: "translate(1.163 0.626)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_160",
    "data-name": "\\u30D1\\u30B9 160",
    d: "M26.232,26.11c1.205.905,3.953,4.8,6.272,4.589l5.467-6.117a20.7,20.7,0,0,0-6.55-3.71",
    transform: "translate(1.163 0.626)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_161",
    "data-name": "\\u30D1\\u30B9 161",
    d: "M29.643,21.122,32.022,22.7a.945.945,0,0,0,1.3-.261l.11-.164a.941.941,0,0,0-.261-1.3L30.8,19.4a.944.944,0,0,0-1.3.26l-.11.165a.94.94,0,0,0,.261,1.3",
    transform: "translate(1.295 0.558)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_211",
    "data-name": "\\u30D1\\u30B9 211",
    d: "M.574,0H1.5a.579.579,0,0,1,.577.578L2.08,4.162a.573.573,0,0,1-.574.575H.58A.576.576,0,0,1,.005,4.16L0,.574A.573.573,0,0,1,.574,0Z",
    transform: "translate(30.157 21.159) rotate(-56.321)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_162",
    "data-name": "\\u30D1\\u30B9 162",
    d: "M28.062,22.468l3.073,2.043a.946.946,0,0,0,1.305-.26l.11-.165a.94.94,0,0,0-.261-1.3l-3.075-2.043a.944.944,0,0,0-1.3.26l-.11.165a.94.94,0,0,0,.261,1.3",
    transform: "translate(1.225 0.614)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_163",
    "data-name": "\\u30D1\\u30B9 163",
    d: "M28.062,22.468l3.073,2.043a.946.946,0,0,0,1.305-.26l.11-.165a.94.94,0,0,0-.261-1.3l-3.075-2.043a.944.944,0,0,0-1.3.26l-.11.165A.94.94,0,0,0,28.062,22.468Z",
    transform: "translate(1.225 0.614)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_164",
    "data-name": "\\u30D1\\u30B9 164",
    d: "M26.955,24.13l3.073,2.043a.946.946,0,0,0,1.305-.26l.11-.165a.94.94,0,0,0-.261-1.3L28.108,22.4a.944.944,0,0,0-1.3.26l-.11.165a.94.94,0,0,0,.261,1.3",
    transform: "translate(1.176 0.684)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_165",
    "data-name": "\\u30D1\\u30B9 165",
    d: "M26.955,24.13l3.073,2.043a.946.946,0,0,0,1.305-.26l.11-.165a.94.94,0,0,0-.261-1.3L28.108,22.4a.944.944,0,0,0-1.3.26l-.11.165A.94.94,0,0,0,26.955,24.13Z",
    transform: "translate(1.176 0.684)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_166",
    "data-name": "\\u30D1\\u30B9 166",
    d: "M26.284,26.082,28.116,27.3a.9.9,0,0,0,1.242-.248l.161-.241a.9.9,0,0,0-.249-1.239l-1.833-1.217A.9.9,0,0,0,26.2,24.6l-.16.24a.894.894,0,0,0,.249,1.239",
    transform: "translate(1.147 0.766)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_212",
    "data-name": "\\u30D1\\u30B9 212",
    d: "M.547,0h.98A.549.549,0,0,1,2.075.55l0,2.893a.545.545,0,0,1-.546.547H.552A.549.549,0,0,1,0,3.44L0,.547A.546.546,0,0,1,.547,0Z",
    transform: "translate(26.687 26.353) rotate(-56.317)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_167",
    "data-name": "\\u30D1\\u30B9 167",
    d: "M35,23.872c-.209-.856-.469-.729-1.985-1.194a1.122,1.122,0,0,1,.5-2.182c2.435.413,4.5,1.386,4.2,4.108l-1.175,1.312",
    transform: "translate(1.428 0.61)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_168",
    "data-name": "\\u30D1\\u30B9 168",
    d: "M35,23.872c-.209-.856-.469-.729-1.985-1.194a1.122,1.122,0,0,1,.5-2.182c2.435.413,4.5,1.386,4.2,4.108l-1.175,1.312",
    transform: "translate(1.428 0.61)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_169",
    "data-name": "\\u30D1\\u30B9 169",
    d: "M68.419,38.791c-.84-.272-.869.016-2.06,1.06a1.131,1.131,0,0,1-1.386.081,1.117,1.117,0,0,1-.211-1.654c1.629-1.851,3.541-3.092,5.707-1.407l.5,1.687",
    transform: "translate(2.859 1.262)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_170",
    "data-name": "\\u30D1\\u30B9 170",
    d: "M68.419,38.791c-.84-.272-.869.016-2.06,1.06a1.131,1.131,0,0,1-1.386.081,1.117,1.117,0,0,1-.211-1.654c1.629-1.851,3.541-3.092,5.707-1.407l.5,1.687",
    transform: "translate(2.859 1.262)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_171",
    "data-name": "\\u30D1\\u30B9 171",
    d: "M67.636,38l-5.21,2.051a.977.977,0,0,0-.479,1.293l.051.114a.982.982,0,0,0,1.3.479l.258-.119-.771.359a1.006,1.006,0,0,0-.494,1.331l.028.061a1.011,1.011,0,0,0,1.335.493l.589-.271-.587.276a1,1,0,0,0-.494,1.33l.028.063a1.009,1.009,0,0,0,1.334.492l.711-.325v.005L65.1,45.7a1.038,1.038,0,1,0,.868,1.886l.274-.126c1.8-.466,5.751-.889,6.688-2.76l-2.352-7.853",
    transform: "translate(2.742 1.294)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_172",
    "data-name": "\\u30D1\\u30B9 172",
    d: "M67.636,38l-5.21,2.051a.977.977,0,0,0-.479,1.293l.051.114a.982.982,0,0,0,1.3.479l.258-.119-.771.359a1.006,1.006,0,0,0-.494,1.331l.028.061a1.011,1.011,0,0,0,1.335.493l.589-.271-.587.276a1,1,0,0,0-.494,1.33l.028.063a1.009,1.009,0,0,0,1.334.492l.711-.325v.005L65.1,45.7a1.038,1.038,0,1,0,.868,1.886l.274-.126c1.8-.466,5.751-.889,6.688-2.76l-2.352-7.853",
    transform: "translate(2.742 1.294)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_173",
    "data-name": "\\u30D1\\u30B9 173",
    d: "M22.193,39.187c0-16.038-4.9-29.039-10.955-29.039S.284,23.149.284,39.187q0,2.161.117,4.24H22.075q.116-2.077.118-4.24",
    transform: "translate(0.013 0.178)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_174",
    "data-name": "\\u30D1\\u30B9 174",
    d: "M22.193,39.187c0-16.038-4.9-29.039-10.955-29.039S.284,23.149.284,39.187q0,2.161.117,4.24H22.075Q22.191,41.35,22.193,39.187Z",
    transform: "translate(0.013 0.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_175",
    "data-name": "\\u30D1\\u30B9 175",
    d: "M.4,42.092c.775,14.028,5.33,24.8,10.837,24.8S21.3,56.12,22.07,42.092Z",
    transform: "translate(0.018 1.513)",
    fill: "#55458c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_176",
    "data-name": "\\u30D1\\u30B9 176",
    d: "M.4,42.092c.775,14.028,5.33,24.8,10.837,24.8S21.3,56.12,22.07,42.092Z",
    transform: "translate(0.018 1.513)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_177",
    "data-name": "\\u30D1\\u30B9 177",
    d: "M.4,42.092c.775,14.028,5.33,24.8,10.837,24.8S21.3,56.12,22.07,42.092Z",
    transform: "translate(0.018 1.513)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_178",
    "data-name": "\\u30D1\\u30B9 178",
    d: "M.4,42.092c.775,14.028,5.33,24.8,10.837,24.8S21.3,56.12,22.07,42.092Z",
    transform: "translate(0.018 1.513)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_179",
    "data-name": "\\u30D1\\u30B9 179",
    d: "M11.118,10.147c-3.228,0-6.13,3.7-8.134,9.593,3.677,3.144,8.158.022,10.814,3.322s5.475,1.946,6.721,1.216c-1.914-8.465-5.408-14.131-9.4-14.131",
    transform: "translate(0.132 0.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_180",
    "data-name": "\\u30D1\\u30B9 180",
    d: "M11.118,10.147c-3.228,0-6.13,3.7-8.134,9.593,3.677,3.144,8.158.022,10.814,3.322s5.475,1.946,6.721,1.216C18.605,15.813,15.112,10.147,11.118,10.147Z",
    transform: "translate(0.132 0.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_181",
    "data-name": "\\u30D1\\u30B9 181",
    d: "M21.718,48.214a53.9,53.9,0,0,1-1.7,7.981,4.13,4.13,0,1,0,1.7-7.981",
    transform: "translate(0.887 1.769)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_182",
    "data-name": "\\u30D1\\u30B9 182",
    d: "M21.718,48.214a53.9,53.9,0,0,1-1.7,7.981,4.13,4.13,0,1,0,1.7-7.981Z",
    transform: "translate(0.887 1.769)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_183",
    "data-name": "\\u30D1\\u30B9 183",
    d: "M21.6,48.2A4.128,4.128,0,0,0,20.132,56.2a53.867,53.867,0,0,0,1.7-7.981c-.078,0-.157-.011-.236-.011",
    transform: "translate(0.774 1.769)",
    fill: "#a64386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_184",
    "data-name": "\\u30D1\\u30B9 184",
    d: "M21.6,48.2A4.128,4.128,0,0,0,20.132,56.2a53.867,53.867,0,0,0,1.7-7.981C21.753,48.21,21.675,48.2,21.6,48.2Z",
    transform: "translate(0.774 1.769)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_185",
    "data-name": "\\u30D1\\u30B9 185",
    d: "M9.723,31.076a3.494,3.494,0,1,0,3.494-3.486,3.49,3.49,0,0,0-3.494,3.486",
    transform: "translate(0.431 0.907)",
    fill: "#fdce7d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_6",
    "data-name": "\\u6955\\u5186\\u5F62 6",
    cx: 3.494,
    cy: 3.486,
    rx: 3.494,
    ry: 3.486,
    transform: "translate(10.154 28.497)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_186",
    "data-name": "\\u30D1\\u30B9 186",
    d: "M29.417,11.648A2.374,2.374,0,1,0,31.791,9.28a2.371,2.371,0,0,0-2.374,2.368",
    transform: "translate(1.304 0.142)",
    fill: "#b965a1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_7",
    "data-name": "\\u6955\\u5186\\u5F62 7",
    cx: 2.374,
    cy: 2.368,
    rx: 2.374,
    ry: 2.368,
    transform: "translate(30.721 9.422)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_12",
    "data-name": "\\u9577\\u65B9\\u5F62 12",
    width: 5.602,
    height: 5.588,
    transform: "translate(15.525 15.24)",
    fill: "#2b9d6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13",
    "data-name": "\\u9577\\u65B9\\u5F62 13",
    width: 5.602,
    height: 5.588,
    transform: "translate(15.525 15.24)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_14",
    "data-name": "\\u9577\\u65B9\\u5F62 14",
    width: 2.763,
    height: 2.757,
    transform: "translate(36.412 63.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15",
    "data-name": "\\u9577\\u65B9\\u5F62 15",
    width: 2.763,
    height: 2.757,
    transform: "translate(36.412 63.545)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_187",
    "data-name": "\\u30D1\\u30B9 187",
    d: "M23.04,76.631a2.7,2.7,0,1,0-2.7,2.689,2.693,2.693,0,0,0,2.7-2.689",
    transform: "translate(0.782 2.844)",
    fill: "#f9b137"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_8",
    "data-name": "\\u6955\\u5186\\u5F62 8",
    cx: 2.695,
    cy: 2.689,
    rx: 2.695,
    ry: 2.689,
    transform: "translate(18.431 76.786)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_188",
    "data-name": "\\u30D1\\u30B9 188",
    d: "M64.232,95.78c-2.327-4.947-1.487-11.9,4.442-14.444,3.689,4.255,1.292,11.726,0,14.444Z",
    transform: "translate(2.794 3.153)",
    fill: "#47adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_189",
    "data-name": "\\u30D1\\u30B9 189",
    d: "M64.232,95.78c-2.327-4.947-1.487-11.9,4.442-14.444,3.689,4.255,1.292,11.726,0,14.444Z",
    transform: "translate(2.794 3.153)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_190",
    "data-name": "\\u30D1\\u30B9 190",
    d: "M69.212,95.644c-1.61-4.039,1.282-8.976,5.386-11.049,2.553,3.474-1.417,8.83-2.311,11.049Z",
    transform: "translate(3.048 3.289)",
    fill: "#2b9d6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_191",
    "data-name": "\\u30D1\\u30B9 191",
    d: "M69.212,95.644c-1.61-4.039,1.282-8.976,5.386-11.049,2.553,3.474-1.417,8.83-2.311,11.049Z",
    transform: "translate(3.048 3.289)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_192",
    "data-name": "\\u30D1\\u30B9 192",
    d: "M66.422,95.345c1.06-5.99,7.781-3.425,8.279,0Z",
    transform: "translate(2.944 3.588)",
    fill: "#2867a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_193",
    "data-name": "\\u30D1\\u30B9 193",
    d: "M66.422,95.345c1.06-5.99,7.781-3.425,8.279,0Z",
    transform: "translate(2.944 3.588)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_194",
    "data-name": "\\u30D1\\u30B9 194",
    d: "M68.945,95.434c-2.689-4.1-3.934-6.827-8.041-5.461s-2.945,5.461-2.945,5.461Z",
    transform: "translate(2.562 3.499)",
    fill: "#f9b137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_195",
    "data-name": "\\u30D1\\u30B9 195",
    d: "M68.945,95.434c-2.689-4.1-3.934-6.827-8.041-5.461s-2.945,5.461-2.945,5.461Z",
    transform: "translate(2.562 3.499)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_196",
    "data-name": "\\u30D1\\u30B9 196",
    d: "M77.6,92.767a2.654,2.654,0,1,0-2.654,2.647A2.651,2.651,0,0,0,77.6,92.767",
    transform: "translate(3.205 3.52)",
    fill: "#de543b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_9",
    "data-name": "\\u6955\\u5186\\u5F62 9",
    cx: 2.654,
    cy: 2.647,
    rx: 2.654,
    ry: 2.647,
    transform: "translate(75.498 93.64)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_5",
    "data-name": "\\u7DDA 5",
    y1: 2.277,
    x2: 4.944,
    transform: "translate(21.285 6.227)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_6",
    "data-name": "\\u7DDA 6",
    x2: 3.222,
    y2: 1.52,
    transform: "translate(22.205 63.546)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_7",
    "data-name": "\\u7DDA 7",
    x2: 2.372,
    y2: 1.576,
    transform: "translate(28.805 33.845)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_197",
    "data-name": "\\u30D1\\u30B9 197",
    d: "M.283,37.561q.016,1.264.06,2.508H4.421A4.684,4.684,0,0,0,.283,37.561",
    transform: "translate(0.013 1.324)",
    fill: "#fdce7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_198",
    "data-name": "\\u30D1\\u30B9 198",
    d: "M.283,37.561q.016,1.264.06,2.508H4.421A4.684,4.684,0,0,0,.283,37.561Z",
    transform: "translate(0.013 1.324)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_199",
    "data-name": "\\u30D1\\u30B9 199",
    d: "M4.418,39.968H.34c.08,2.33.23,4.608.448,6.811a4.677,4.677,0,0,0,4.166-4.644,4.645,4.645,0,0,0-.536-2.167",
    transform: "translate(0.015 1.424)",
    fill: "#a64386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_200",
    "data-name": "\\u30D1\\u30B9 200",
    d: "M4.418,39.968H.34c.08,2.33.23,4.608.448,6.811a4.677,4.677,0,0,0,4.166-4.644A4.645,4.645,0,0,0,4.418,39.968Z",
    transform: "translate(0.015 1.424)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_201",
    "data-name": "\\u30D1\\u30B9 201",
    d: "M33.562,33.759a2.744,2.744,0,0,0,5.353.839,30.2,30.2,0,0,1-4.032-3.175,2.731,2.731,0,0,0-1.321,2.337",
    transform: "translate(1.488 1.067)",
    fill: "#b965a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_202",
    "data-name": "\\u30D1\\u30B9 202",
    d: "M33.562,33.759a2.744,2.744,0,0,0,5.353.839,30.2,30.2,0,0,1-4.032-3.175A2.731,2.731,0,0,0,33.562,33.759Z",
    transform: "translate(1.488 1.067)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_203",
    "data-name": "\\u30D1\\u30B9 203",
    d: "M36.249,31.038a2.735,2.735,0,0,0-1.421.4,30,30,0,0,0,4.032,3.176,2.737,2.737,0,0,0-2.611-3.575",
    transform: "translate(1.544 1.051)",
    fill: "#47adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_204",
    "data-name": "\\u30D1\\u30B9 204",
    d: "M36.249,31.038a2.735,2.735,0,0,0-1.421.4,30,30,0,0,0,4.032,3.176,2.737,2.737,0,0,0-2.611-3.575Z",
    transform: "translate(1.544 1.051)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_205",
    "data-name": "\\u30D1\\u30B9 205",
    d: "M46.126,47.223a2.374,2.374,0,1,0-4.7.468h4.654a2.377,2.377,0,0,0,.047-.468",
    transform: "translate(1.834 1.629)",
    fill: "#f4bcaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_206",
    "data-name": "\\u30D1\\u30B9 206",
    d: "M46.126,47.223a2.374,2.374,0,1,0-4.7.468h4.654A2.377,2.377,0,0,0,46.126,47.223Z",
    transform: "translate(1.834 1.629)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_207",
    "data-name": "\\u30D1\\u30B9 207",
    d: "M41.422,47.577a2.375,2.375,0,0,0,4.654,0Z",
    transform: "translate(1.836 1.742)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_208",
    "data-name": "\\u30D1\\u30B9 208",
    d: "M41.422,47.577a2.375,2.375,0,0,0,4.654,0Z",
    transform: "translate(1.836 1.742)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_209",
    "data-name": "\\u30D1\\u30B9 209",
    d: "M55.725,20.325h-.815a.49.49,0,0,1-.451-.686,4.309,4.309,0,0,0,.408-1.3v-.383l.718-.021",
    transform: "translate(2.412 0.504)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_210",
    "data-name": "\\u30D1\\u30B9 210",
    d: "M55.725,20.325h-.815a.49.49,0,0,1-.451-.686,4.309,4.309,0,0,0,.408-1.3v-.383l.718-.021",
    transform: "translate(2.412 0.504)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallImage2);
export default __webpack_public_path__ + "static/media/call-image--2.bcad9111d1850708fb725c1cedac75b3.svg";
export { ForwardRef as ReactComponent };